import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ITriggerActionButtonProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ITriggerActionButtonProps>>
): IComponentSchema<ITriggerActionButtonProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Action Trigger Button',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.TriggerActionButton,
    'x-component-props': {
      text: props?.['x-component-props']?.text || 'Save',
      transformer: '{ modelInstanceId: $instance.id }',
      confirm: {
        ...(props?.['x-component-props']?.confirm || {}),
        show: props?.['x-component-props']?.confirm?.show || true,
      },
    },
    'x-component-props-config': {},
  };
};
